import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ExportInitiatedDialog from './index';
import { resetExportInitiatedDialog } from './redux/exportInitiatedDialogSlice';

const ExportInitiatedDialogProvider: React.FC = () => {
  const dispatch = useDispatch();
  const { open, reportId } = useSelector((state: any) => ({
    open: state.exportInitiatedDialog.exportInitiated,
    reportId: state.exportInitiatedDialog.reportId,
  }));
  
  const handleDialogClose = () => {
    dispatch(resetExportInitiatedDialog());
  };

  if (!open) return null;

  return (
    <ExportInitiatedDialog
      openExportInitiatedInfo={open}
      handleDialogClose={handleDialogClose}
      reportId={reportId}
    />
  );
};

export default ExportInitiatedDialogProvider;
